import { PrivateAPINamespace } from '../PrivateAPINamespace';
class AppController {
    constructor(ds, appController) {
        this.ds = ds;
        this.appController = appController;
        this.id = this.appController.id;
        this.settings = this.appController.settings;
    }
    update(newSettings) {
        return this.ds.platform.controllers.settings.set({ id: this.appController.id, type: 'data' }, newSettings);
    }
}
export class ControllersNamespace extends PrivateAPINamespace {
    async get(appDefinitionId, compRef) {
        return this.ps.ds.platform.controllers
            .getAvailableScopedControllers(compRef)
            .filter((controller) => controller.applicationId === appDefinitionId)
            .map((appController) => new AppController(this.ps.ds, appController));
    }
}
ControllersNamespace.namespace = 'controllers';
//# sourceMappingURL=ControllersNamespace.js.map